import { useUtils } from "@/app/hooks/useUtils";

type MembershipUsageProps = {
  coupon: any;
  usages?: any[];
};

const MembershipUsage: React.FC<MembershipUsageProps> = ({ coupon, usages }) => {
  const { veticDateFormat } = useUtils();
  const inCart = (usages ?? []).some((usage: any) => usage.coupon_id === coupon.coupon_id && usage.in_cart);
  const percent = coupon.limit ? Math.min(coupon.used / coupon.limit, 1) * 100 : 0;
  const note = inCart
    ? "used in this cart"
    : coupon.last_used_date
      ? `last used ${veticDateFormat(coupon.last_used_date)?.slice(0, 9)}`
      : null;

  return (
    <div className="flex flex-col gap-[4px] w-full">
      <div className="flex items-center justify-between gap-[10px]">
        <p className="flex-1 text-[20px] font-medium text-black truncate">{coupon.display_text}</p>
        {note && (
          <span className="flex items-center gap-[2px] shrink-0 text-[14px] font-medium text-black">
            <img src="/membership_last_used.svg" alt="" className="w-[14px] h-[14px]" />
            {note}
          </span>
        )}
      </div>
      <div className="flex items-center justify-between gap-[46px]">
        <div className="flex-1 h-[6px] bg-[#e3e3e3] rounded-full overflow-hidden">
          <div className="h-full bg-[#f05b72] rounded-full" style={{ width: `${percent}%` }} />
        </div>
        <span className="w-[30px] text-right text-[18px] font-semibold text-black">
          {coupon.used}/{coupon.limit}
        </span>
      </div>
    </div>
  );
};

export default MembershipUsage;
